import { isUndefined, isNull } from 'lodash';

/* eslint-disable no-unused-vars */
// TODO: remove once upgraded to redux-form v6, which makes this redundant
export default ({
  initialValue,
  autofill,
  onUpdate,
  valid,
  invalid,
  dirty,
  pristine,
  active,
  touched,
  visited,
  autofilled,
  error,
  value,
  // onBlur,
  ...domProps
}) => ({
  ...domProps,
  value: isUndefined(value) || isNull(value) ? '' : value,
});
/* eslint-enable no-unused-vars */
